import { FILTERS } from '@/models/common/filters';

export const filterTooltips: Partial<Record<string, string>> = {
  // Basic filters with provided descriptions
  [FILTERS.columnTopic]:
    "The main subject of the conversation, reflecting the user's general intent or area of interest.",
  [FILTERS.columnCategory]: 'Customer-defined sub-topic label for deeper segmentation within a broader topic.',
  [FILTERS.columnConversationCategory]:
    'Customer-defined sub-topic label for deeper segmentation within a broader topic, at the conversation level.',
  [FILTERS.columnLanguage]:
    'Language used in the interaction; supports multilingual analytics and performance across locales.',
  [FILTERS.columnUser]:
    'Unique identifier for the user; used for Return rate, Activation rate, and cohort-based segmentation.',
  [FILTERS.columnPii]: 'When personally identifiable information was shared; useful for compliance and risk filtering.',
  [FILTERS.columnCohort]: 'Custom-defined grouping of users, useful for cohort analysis.',
  [FILTERS.columnIntent]:
    "Detected goal behind the user's query, useful for analyzing user motivation and conversation quality.",
  [FILTERS.columnUserAction]: 'Represents what users actively do during a conversation at the conversation level.',
  [FILTERS.columnSubject]:
    'Specific words or phrases mentioned; helpful for tagging, trend spotting, and User intent classification.',
  [FILTERS.columnFeedbackTypeV2]:
    'Direct positive or negative responses from users; critical for understanding User feedback and satisfaction trends.',
  [FILTERS.columnSentiment]: 'Overall emotional tone of user inputs (positive, neutral, negative).',
  [FILTERS.columnConversationSentiment]:
    'Overall sentiment of the conversations within a category (topic, user intent, user problem, etc).',
  [FILTERS.columnEmotions]: 'Discrete emotional states (e.g., angry, happy).',
  [FILTERS.columnConversationTopic]:
    "The main subject of the conversation, reflecting the user's general intent or area of interest at the conversation level.",
  [FILTERS.columnConversationUserAction]:
    'Represents what users actively do during a conversation at the conversation level.',
  [FILTERS.columnTypeOfProblemV2]:
    'More detailed classification of problem type, refining analysis of Explicit error rate, and usability gaps.',
  [FILTERS.columnSessionLength]:
    'Number of user-LLM exchanges; strongly tied to Avg. interactions/conversations and Duration.',
  [FILTERS.firstInteraction]: 'Users whose first interaction is in a specific time period',
  [FILTERS.lastInteraction]: 'Users whose last interaction is in a specific time period',
  [FILTERS.userConversationsCount]: 'Users who have had at least a specific number of conversations',
  [FILTERS.userConversationLength]: 'Users whose conversations have a specific messages count in terms of interactions',
  [FILTERS.usersInteraction]: 'Users who have had at least a specific number of interactions',

  // Additional filter kinds with provided descriptions
  user_rating: 'Explicit numeric rating by the user, typically on a scale (e.g., 1-5 stars).',
  has_user_comment: 'Free-form user feedback in-text, useful for User feedback and qualitative insights.',
  type_of_risk:
    'Potential impact from user interactions (e.g., legal, reputational); supports strategic analysis beyond Error rate.',
  positive_comment:
    'Explicitly positive user comment; supports tracking user satisfaction beyond ratings (User sentiment).',
  conversation_id:
    'Unique session identifier; used for session-based metrics like Duration, Conversations, and Bounce rate.',
  conversation_user_query:
    "Structured representation of the user's request extracted from the interaction at the conversation level.",
  user_query: "Structured representation of the user's request extracted from the interaction.",
  [FILTERS.columnConversationErrorStatus]:
    'Conversation-level status indicating if a conversation ended with an error condition.',
  user_interaction_position:
    'Indicates whether the interaction occurs at the start or end of a conversation, useful for entry/exit behavior analysis.',
  data_source: 'Information source used for retrieval-based answers; helps diagnose Error rate and trust in results.',
  negative_user_intent_v2: 'Risky behaviors show potential issues that need attention in your conversations.',
  out_of_scope_suggestion: "Queries the LLM couldn't handle, directly influencing Out of scope rate.",
  pii_processed: 'Marks vague or unclear user input; tied to Poor prompt quality rate.',
};

export const getFilterTooltip = (filterKey: string): string | undefined => {
  //if (filterKey.startsWith('tag:')) {
  //  return 'Custom label applied to this conversation for organization and filtering.';
  //}
  //
  //// Handle custom aggregate filters
  //if (filterKey.startsWith('custom_aggregate:')) {
  //  return 'Custom metric calculated based on specific business requirements.';
  //}
  //
  //if (filterKey.startsWith('conversation_custom_aggregate:')) {
  //  return 'Custom conversation-level metric for specialized analysis.';
  //}
  //
  //// Handle custom column filters
  //if (filterKey.startsWith('custom:')) {
  //  return 'Custom data field specific to your organization.';
  //}
  //
  //if (filterKey.startsWith('conversation_custom:')) {
  //  return 'Custom conversation-level data field specific to your organization.';
  //}

  // Return predefined tooltip
  return filterTooltips[filterKey];
};
